import React, { useState } from 'react';

function ClothingSelector({ items, onChange, artikel, rabattAktiv }) {
  const [popupBild, setPopupBild] = useState(null);

  const handleQuantityChange = (key, delta) => {
    const currentValue = items[key] || 0;
    const newValue = Math.max(0, Math.min(99, currentValue + delta));
    onChange({ ...items, [key]: newValue });
  };

  const handleInputChange = (key, value) => {
    const clampedValue = Math.max(0, Math.min(99, parseInt(value) || 0));
    onChange({ ...items, [key]: clampedValue });
  };

  const renderQuantityControl = (key) => {
    const value = items[key] || 0;
    return (
      <div className="d-flex align-items-center justify-content-center">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm quantity-btn"
          onClick={() => handleQuantityChange(key, -1)}
          disabled={value <= 0}
        >
          −
        </button>
        <input
          type="number"
          className="form-control form-control-sm text-center mx-1"
          style={{ width: '60px' }}
          min="0"
          max="99"
          value={value}
          onChange={(e) => handleInputChange(key, e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm quantity-btn"
          onClick={() => handleQuantityChange(key, 1)}
        >
          +
        </button>
      </div>
    );
  };

  return (
    <div className="card mb-4">
      <div className="card-header">
        <h5 className="mb-0">Artikelauswahl</h5>
      </div>
      <div className="card-body">
        <div className="alert alert-warning" role="alert">
          <strong>Achtung: Nur Barzahlung möglich!</strong><br />
          Wir informieren Sie, wenn Sie Ihre Ware im Schulbüro abholen können.
        </div>

        {Object.entries(artikel || {}).map(([key, art]) => {
          const hasGroessen = art.groessen && art.groessen.length > 0;
          return (
            <div key={key} className="clothing-item p-3 border rounded mb-3">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="d-flex align-items-center gap-2">
                    {art.bildUrl && (
                      <div style={{ flexShrink: 0, textAlign: 'center' }}>
                        <button
                          type="button"
                          onClick={() => setPopupBild({ name: art.name, bildUrl: art.bildUrl })}
                          aria-label={`Bild von ${art.name} vergrößern`}
                          style={{
                            background: 'none',
                            border: '2px solid #dee2e6',
                            borderRadius: 6,
                            padding: 2,
                            cursor: 'pointer',
                            display: 'block',
                            lineHeight: 0,
                          }}
                        >
                          <img
                            src={art.bildUrl}
                            alt={art.name}
                            style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 3, display: 'block' }}
                          />
                        </button>
                        <button
                          type="button"
                          onClick={() => setPopupBild({ name: art.name, bildUrl: art.bildUrl })}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: '2px 0 0',
                            cursor: 'pointer',
                            fontSize: '0.7rem',
                            color: '#0d6efd',
                            textDecoration: 'underline',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Foto ansehen
                        </button>
                      </div>
                    )}
                    <div>
                      <h6 className="mb-1">{art.name}</h6>
                      <span className="text-muted">{art.preis} € pro Stück</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    {hasGroessen ? (
                      art.groessen.map((groesse) => (
                        <div key={groesse} className="col-6 col-sm-4 col-md-6 col-lg-4 mb-2">
                          <label className="form-label small text-muted mb-1">
                            Größe {groesse}
                          </label>
                          {renderQuantityControl(`${key}_${groesse}`)}
                        </div>
                      ))
                    ) : (
                      <div className="col-6 col-sm-4 col-md-6 col-lg-4 mb-2">
                        <label className="form-label small text-muted mb-1">Anzahl</label>
                        {renderQuantityControl(`${key}_anzahl`)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Produktbild-Popup */}
      {popupBild && (
        <div
          onClick={() => setPopupBild(null)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.65)',
            zIndex: 1050,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              background: '#fff',
              borderRadius: 8,
              padding: 16,
              maxWidth: '90vw',
              maxHeight: '90vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
            }}
          >
            <button
              type="button"
              onClick={() => setPopupBild(null)}
              aria-label="Schließen"
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: 32,
                height: 32,
                cursor: 'pointer',
                fontSize: 18,
                lineHeight: '32px',
                textAlign: 'center',
                padding: 0,
              }}
            >
              ×
            </button>
            <p className="fw-semibold mb-2 text-center" style={{ paddingRight: 40 }}>{popupBild.name}</p>
            <img
              src={popupBild.bildUrl}
              alt={popupBild.name}
              style={{
                maxWidth: '80vw',
                maxHeight: '75vh',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ClothingSelector;
